// Only batch-removal recovery lives here. Do not clear unrelated browser data.
const PREFIX=/^rand-batch-removal(?:-pending)?:[^\s]+$/;
function stores(overrides){
 if(overrides)return [overrides.session,overrides.local];
 let session,local;try{session=globalThis.sessionStorage;}catch{}try{local=globalThis.localStorage;}catch{}
 return [session,local];
}
function read(store,key){
 try{
  const raw=store?.getItem(key);if(raw==null)return null;
  const parsed=JSON.parse(raw);
  if(parsed?.__randBatchRecovery===1&&Number.isSafeInteger(parsed.at)&&Object.hasOwn(parsed,'value'))return {at:parsed.at,value:parsed.value};
  return {at:0,value:parsed};
 }catch{return null;}
}
function candidates(key,overrides){return stores(overrides).map(store=>({store,record:read(store,key)}));}
export function readBatchRemovalStorage(key,overrides){
 if(!PREFIX.test(key))return null;
 const entries=candidates(key,overrides).filter(item=>item.record).sort((a,b)=>b.record.at-a.record.at);
 return entries[0]?.record.value??null;
}
export function writeBatchRemovalStorage(key,value,overrides){
 if(!PREFIX.test(key))return false;
 const entries=candidates(key,overrides);
 const at=Math.max(Date.now(),...entries.map(item=>(item.record?.at||0)+1));
 let raw;try{raw=JSON.stringify({__randBatchRecovery:1,at,value:value??null});}catch{return false;}
 const write=store=>{try{if(!store)return false;store.setItem(key,raw);return true;}catch{return false;}};
 const primary=write(entries[0].store);
 // Refresh any previous fallback after a primary write. Null tombstones go to
 // both stores, so an older pending action cannot reappear after completion.
 const backup=(!primary||entries[1].record||value==null)?write(entries[1].store):false;
 return primary||backup;
}
